import { IViewModel } from '../../interfaces/view-model.interface';

export class SimplifiedTreeNodePermissions implements IViewModel {
    public id: number = 0; // This is a dummy Id value to satisfy interface IViewModel, a requirement for service class PermissionsTestingService.

    public dataCollectionId: number;
    public rootFolderId: number;

    public parentFolderId: number;
    public objectTypeAndId: string;
    public nodeOrder: number;
    public objectType: string;
    public objectId: number; // The folder or form instance Id.
    public objectName: string;
    public isReference: number;
    public referencedObjectId: number;

    public magicStructureId: number;
    public magicMembershipStructureName: string;

    public isSiteAdmin: number;

    public canBuildRoles: number; // 1 if the user is a site admin; 0 otherwise.
    public canBuildWorkflows: number; // 1 if the user is a site admin; 0 otherwise.
    public canBuildForms: number; // 1 if the user is a site admin; 0 otherwise.
    public canBuildFolders: number; // 1 if the user is a site admin; 0 otherwise.
    public canBuildFormInstances: number; // 1 if the user is a site admin; 0 otherwise.

    public canViewFolder: number; // New folder-only permission
    public canCreateFolder: number; // New folder-only permission
    public canDeleteFolder: number; // New folder-only permission
    public canCreateForm: number; // New folder-only permission
    public canDeleteForm: number; // New folder-only permission
    public canGrantPermission: number; // New folder-only permission
    public canManageRoleMembers: number; // New folder-only permission

    public canViewFormInstance: number; // Still derived from the form instance's workflow
    public canEditFormInstance: number; // Still derived from the form instance's workflow

    public canTransition: number;
}
